import { Autocomplete } from 'src/components/Autocomplete';
import { TextField } from 'src/components/TextField';

interface PurchaseTypeFilterProps {
  field: string;
  label: string;
  value: string[] | undefined;
  setValue: (newVal: string[]) => void;
  valueOnly?: boolean;
}

const purchaseTypes = [
  { id: 'purchase', name: 'One Time Purchase' },
  { id: 'subscription', name: 'Subscription' },
];

export const PurchaseTypeFilter: React.FC<PurchaseTypeFilterProps> = ({
  label,
  value,
  setValue,
  valueOnly,
}) => {
  const selectedValues = value ? String(value).split(',') : [];

  if (valueOnly) {
    return selectedValues.length > 0 ? (
      <>
        {selectedValues
          .map(
            (v) => purchaseTypes.find((option) => option.id === v)?.name || ''
          )
          .join(', ')}
      </>
    ) : null;
  }

  const selectedOptions = selectedValues.map(
    (v) => purchaseTypes.find((option) => option.id === v) || { id: v, name: v }
  );

  return (
    <Autocomplete
      multiple
      options={purchaseTypes}
      getOptionLabel={(option) =>
        typeof option === 'string'
          ? purchaseTypes.find((o) => o.id === option)?.name || option
          : option.name
      }
      value={selectedOptions}
      onChange={(_, newValue) => {
        setValue(
          newValue.map((v) => (typeof v === 'string' ? v : v.id)).join(',')
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder="Select Purchase Type"
        />
      )}
      isOptionEqualToValue={(option, value) =>
        option.id === (typeof value === 'string' ? value : value.id)
      }
    />
  );
};
